module.exports = __webpack_public_path__ + "img/profitable-img-1.887a1d96.png";